const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value) {
  return EMAIL_REGEX.test(String(value || '').trim());
}

export function findInvalidEmail(addresses) {
  return addresses.find(a => !isValidEmail(a)) || null;
}

export function areEmailsValid(addresses) {
  return addresses.length > 0 && addresses.every(isValidEmail);
}

export function getPhoneDigits(value) {
  return String(value || '').replace(/\D/g, '');
}

export function isValidPhone(value) {
  const digits = getPhoneDigits(value);
  return digits.length >= 7 && digits.length <= 15;
}
